module.exports = __webpack_public_path__ + "img/lock-grey.b8926549.svg";